import LoginBackgroundImage from "../../../assets/images/LoginBackgroungImage.svg";
import { MobileResponsiveLoginComponent } from "../../../mobileResponsive/components/common/LoginComponent";
import { LoginComponent } from "../../../components/common/LoginComponent";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/store";
import { fetchLoginFormAsync } from "../../../store/thunks/LoginThunk";
import PhoneNumberLoginIcon from "../../../assets/images/PhoneNumberLoginIcon";
import UserIdLoginIcon from "../../../assets/images/UserIdLoginIcon";
import FaceRecognitionIcon from "../../../assets/images/FaceRecognitionIcon";
import FingerPrintLoginIcon from "../../../assets/images/FingerPrintLoginIcon";
import { readFromLocalStorage } from "../../../utils/DataEncryption";
import Loader from "../../common/styles/Loader";
import { b2cErrorCode, ErrorMessage } from "../../../constants/constants";
import { PopupMessage } from "../../common/SideMenuStaffVerification";

const Login = () => {
  const dispatch = useDispatch<AppDispatch>();
  const loginForm = useSelector(
    (state: RootState) => state.loginDetails.loginFormDetails
  );
  const [showLoader, setShowLoader] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState<PopupMessage>({
    title: "",
    message: "",
  });
  const [errorCode, setErrorCode] = useState("");
  const [userName, setUserName] = useState("");
  const [selectedLoginMethod, setSelectedLoginMethod] = useState("");

  const urlString = window.location.href;
  const url = new URL(urlString);
  const params = new URLSearchParams(url.search);
  const appIdFromParms = params.get("app_id");
  useEffect(() => {
    const appId =
      appIdFromParms ||
      readFromLocalStorage("appId") ||
      process.env.REACT_APP_APPID;
    dispatch(fetchLoginFormAsync(appId));
  }, [dispatch,appIdFromParms]);

  useEffect(() => {
    if ((loginForm?.authMethods ?? []).length > 0) {
      setSelectedLoginMethod(loginForm?.authMethods[0] || "");
    }
    setShowLoader(false);
  }, [loginForm]);

  useEffect(() => {
    if (errorMessage.message != "") {
      setShowPopup(true);
    } else {
      setShowPopup(false);
    }
  }, [errorMessage]);
  useEffect(() => {
    if (errorCode === b2cErrorCode.monthlyConfirmationError) {
      setErrorMessage({
        title: ErrorMessage.monthlyConfirmationErrorTitle,
        message: `${userName} ${ErrorMessage.monthlyConfirmationError}`,
      });
    } else if (errorCode === b2cErrorCode.loginError) {
      setErrorMessage({ title: "", message: ErrorMessage.loginError });
    }
  }, [errorCode]);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const errorFromB2c = urlParams.get("errorMessage");
    const userNameFormB2c = urlParams.get("userName");
    if (errorFromB2c) {
      if(userNameFormB2c){
        setUserName(userNameFormB2c);
      }
      setErrorCode(errorFromB2c);
    }
  }, []);

  // Define the icon map for login methods
  const iconMap: Record<string, React.ComponentType<any>> = {
    OTP: PhoneNumberLoginIcon,
    UID: UserIdLoginIcon,
    FID: FaceRecognitionIcon,
    FP: FingerPrintLoginIcon,
  };

  // Dynamically generate login methods based on API response
  const getLoginMethods = () => {
    return (
      loginForm?.authMethods?.map((method) => ({
        method,
        label:
          method === "OTP"
            ? "Phone Number and OTP"
            : method === "UID"
            ? "Employee ID and Password"
            : method === "FID"
            ? "Face Recognition"
            : method === "FP"
            ? "Fingerprint Login"
            : "Unknown Method",
        icon: iconMap[method] || null,
        image: loginForm?.logoImageUrl || "",
        appName: loginForm?.title || "",
      })) || []
    );
  };

  const onClose = () => {
    setShowPopup(false);
    if (errorCode === b2cErrorCode.monthlyConfirmationError) {
      setSelectedLoginMethod("FID");
      sessionStorage.removeItem("b2cErrorCode");

    }
  };

  return (
    <>
      {/* Mobile View */}
      <div className="block lg:hidden">
        {showLoader ? (
          <Loader />
        ) : (
          <>
            <MobileResponsiveLoginComponent
              loginMethods={getLoginMethods()}
              showPopup={showPopup}
              onPopupClose={onClose}
              errorMessage={errorMessage}
              style={{
                modalstyle: "w-[90vw]  bg-white rounded-lg p-4",
                backGroundStyle: "bg-opacity-50 bg-gray-900",
              }}
              selectedLoginMethod={selectedLoginMethod}
              setSelectedLoginMethod={setSelectedLoginMethod}
            />
          </>
        )}
      </div>
      {/* Web View */}
      <div className="h-screen w-screen hidden lg:block">
        {showLoader ? (
          <div className="items-center justify-center bg-white">
            <Loader />
          </div>
        ) : (
          <>
            <img
              style={{ width: "100vw", height: "100vh" }}
              alt="ProfileImg"
              src={LoginBackgroundImage}
            />
            <LoginComponent
              loginMethods={getLoginMethods()}
              showPopup={showPopup}
              onPopupClose={onClose}
              errorMessage={errorMessage}
              style={{
                modalstyle: "w-[30vw]  bg-white rounded-lg p-6",
                backGroundStyle: "bg-blackColor bg-opacity-35",
              }}
              selectedLoginMethod={selectedLoginMethod}
              setSelectedLoginMethod={setSelectedLoginMethod}
            />
          </>
        )}
      </div>
    </>
  );
};

export default Login;
